// @ts-nocheck
import { Component, OnInit } from '@angular/core';
import { UIKitIconRegistry } from '../../icon/icon.registry';
import { cookieIcon } from '../../icon/cookie/cookie';
import { closeIcon } from '../../icon/close/close';
import { CookieConsentService } from '../../service/cookie-consent.service';

@Component({
  selector: 'lib-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
  exportAs: 'libCookieConsent',
})
export class CookieConsentComponent implements OnInit {
  accepted: boolean;

  constructor(
    private cookieConsent: CookieConsentService,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([cookieIcon, closeIcon]);
  }

  ngOnInit(): void {
    this.cookieConsent.event
      .subscribe(this.update.bind(this));

    this.update();
  }

  /**
   *
   */
  accept(event: MouseEvent | TouchEvent): void {
    this.cookieConsent.accept();
  }

  /**
   *
   */
  private update(): void {
    this.accepted = this.cookieConsent.accepted;
  }
}
